import { isJunk } from 'junk';

// Microsoft Office owner/lock files (e.g. `~$report.docx`) left behind by open documents.
const MS_OFFICE_OWNER_FILE_PREFIX = '~$';

/**
 * Filters OS/application junk out of the File list extracted by react-dropzone.
 * react-dropzone only drops `.DS_Store`/`Thumbs.db`, so this extends that with
 * the `junk` package's curated OS junk list plus Microsoft Office owner files.
 * Everything else is uploaded exactly as dragged in — names are never mutated.
 */
export function filterJunkFiles(droppedFiles: File[]): File[] {
  return droppedFiles.filter(file => !getIsJunkFile(file.name));
}

function getIsJunkFile(fileName: string): boolean {
  return isJunk(fileName) || fileName.startsWith(MS_OFFICE_OWNER_FILE_PREFIX);
}
